import React from "react";
import styles from './Card.module.scss';
import ProfilePicture from "../profilePicture/ProfilePicture";
import Button from "../button/Button";
import Icon from "../icon/Icon";
import PropTypes from "prop-types";
import EvaluationStatus from "../evaluationStatus/EvaluationStatus";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import Tooltip from "../tooltip/Tooltip";
import Tag from "../tag/Tag";

const Card = ({
  profilePicture,
  firstName,
  lastName,
  data,
  isAssigned,
  status,
  onClick,
  onActionClick,
  onTransferClick,
  isLoading,
}) => {
  const showFooter = onActionClick || onTransferClick;

  const renderActions = () => {
    if (isLoading) return <LoadingSpinner size={20} />;
    if (status === 'Pending') {
      return (
        <>
          <Button
            label="Decline"
            size="small"
            variant="secondary"
            onClick={(e) => { e.stopPropagation(); onActionClick('Declined'); }}
          />
          <Button
            label="Accept"
            size="small"
            onClick={(e) => { e.stopPropagation(); onActionClick('Accepted'); }}
          />
          <Tooltip
            content={
              <ul>
                <li>Click 'Accept or Decline' in the student's profile to manage your student assignment.</li>
                <li>If you 'Decline' a student assignment, nothing more is required. Thank you! (Program may contact you).</li>
                <li>If you 'Accept' a student assignment, an evaluation is created. To begin, click on the student profile.</li>
              </ul>
            }
            position="left"
          />
        </>
      );
    }
    return <EvaluationStatus status={status} />;
  };

  return (
    <div
      className={`${styles.card} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
    >
      <div className={styles.header}>
        <div className={styles.profile}>
          <ProfilePicture
            profilePicture={profilePicture}
            firstName={firstName}
            lastName={lastName}
          />
          <h4>{firstName} {lastName} {isAssigned ? <Tag text="My Student" variant={2} /> : <Tag text="Other Student" variant={3} />}</h4>
        </div>
      </div>
      <table className={styles.table}>
        <tbody>
          {data.map(item => (
            <tr key={item.label}>
              <th>{item.label}</th>
              <td title={item.tooltip ?? ''}>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {showFooter && <hr />}
      {showFooter && (
        <div className={styles.footer}>
          {onTransferClick && status === 'Pending' && (
            <button
              type="button"
              className={styles.transferBtn}
              onClick={(e) => { e.stopPropagation(); onTransferClick(); }}
            >
              <Icon name="arrow-up-right" />
              Transfer
            </button>
          )}
          {onActionClick && <div className={styles.footerActions}>{renderActions()}</div>}
        </div>
      )}
    </div>
  );
};

Card.propTypes = {
  profilePicture: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  isAssigned: PropTypes.bool.isRequired,
  status: PropTypes.string,
  onClick: PropTypes.func,
  onActionClick: PropTypes.func,
  onTransferClick: PropTypes.func,
  isLoading: PropTypes.bool
};

export default Card;
